import React from 'react'
import { Typography } from '@mui/material'

function Version() {
    return (
        <Typography
            variant="body2"
            color="text.secondary"
            align="center"
            sx={{ mt:2 }}
        >
            Version 1.6.8
        </Typography>
    )    

}

export default Version;